module.exports = __webpack_public_path__ + "img/logo_gs.7bfc423c.png";